/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum TaxIdStatus {
    /**
     * The tax ID could not be successfully validated against the relevant external tax
     * authority database.
     */
	Unverified = 'Unverified',
    /**
     * The tax ID has been successfully validated against the relevant external tax
     * authority database.
     */
	Verified = 'Verified',
    /**
     * The tax ID has been submitted, and the verification process is currently underway.
     */
	Pending = 'Pending',
    /**
     * The tax ID has not been checked with an external tax authority. Either the check was
     * attempted and failed, or validation is not supported for the tax ID type.
     */
	Unknown = 'Unknown',
}
